import FillSymbol from './FillSymbol';

/**
 * 简单面符号,只支持纯色填充.
 */
export default class SimpleFillSymbol extends FillSymbol {
    constructor(options) {
        super(options);

        this.color = 'black';

        this.type = 'SimpleFillSymbol';

        this.fromJson(options);
    }

    fromJson(json) {
        super.fromJson(json);
        this._setValue('color', json.color);
    }

    toJson() {
        const json = super.toJson();
        json.color = this.color;
        return json;
    }

    /**
     * 通过单一色绘制面并填充颜色.
     * @param {Object} ctx - 设备上下文,通过canvas.getContext('2d')方法获得.
     * @returns {undefined}
     */
    _drawContent(ctx, geometry) {

        // 绘制
        ctx.beginPath();
        this._drawLineString(ctx, geometry.coordinates[0]);
        if(geometry.coordinates.length > 0) {
            for(let i = 1; i < geometry.coordinates.length; i++) {
                this._drawLineString(ctx, geometry.coordinates[i]);
            }
        }
        // 设置绘制环境
        ctx.fillStyle = this.color;
        ctx.globalAlpha = this.opacity;
        ctx.strokeStyle = 'rgba(0.5, 0.5, 0.5)';
        ctx.fill();
        ctx.stroke();
    }
}
